import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserSettingsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M23.383 19h2.234l.316 1.576a1.29 1.29 0 0 0 1.13.63l1.82-.388L30 22.682l-1.117 1.189c-.238.388-.238.87 0 1.258L30 26.318l-1.117 1.864-1.82-.388a1.29 1.29 0 0 0-1.13.63L25.617 30h-2.234l-.316-1.576a1.29 1.29 0 0 0-1.13-.63l-1.82.388L19 26.318l1.117-1.189c.238-.388.238-.87 0-1.258L19 22.682l1.117-1.864 1.82.388c.467.005.901-.236 1.13-.63zm1.117 7.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666" />
      <path d="m18.003 15.989 1.555.315a14.7 14.7 0 0 1 2.442.802c-3.054.865-5.294 3.699-5.294 7.06 0 .634.08 1.248.229 1.834H5.555A1.566 1.566 0 0 1 4 24.425v-3.151c0-2.198 2.536-4.088 6.223-4.97 0 0 1.02-.229 1.556-.315a7.67 7.67 0 0 1-2.334-5.349V9.514c0-1.97 1.038-3.79 2.723-4.775a5.39 5.39 0 0 1 5.445 0 5.53 5.53 0 0 1 2.723 4.775v1.126a7.72 7.72 0 0 1-2.333 5.348z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconUserSettingsFilledSVG);
ForwardRef.displayName = "IconUserSettingsFilled";
export { ForwardRef as IconUserSettingsFilled };
